/**
 * Veeso Unsplash API definitions
 */

import { defHTTP } from '../../api-builder';
import type { UnsplashSearchParams, UnsplashSearchResponse } from './types';

/**
 * Unsplash API definitions for use with apiBuilder
 */
export const unsplashAPIDefinitions = {
  /**
   * Search Unsplash images
   */
  searchUnsplash: defHTTP<UnsplashSearchParams, UnsplashSearchResponse>(
    'GET',
    '/unsplash/search/photos'
  ),
};
